import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
  return headers;
};

const getAuthHeadersForFiles = () => {
    const token = localStorage.getItem('authToken');
    return {
        'Authorization': `Bearer ${token}`
    };
};

const gradeOptions = [
  'Kindergarten', '1st Grade', '2nd Grade',
  '3rd Grade', '4th Grade', '5th Grade'
];

const filterGradeOptions = [
  '',
  ...gradeOptions
];

function AdminPage({ onSignOut }) {
  const [tab, setTab] = useState('teachers');
  const navigate = useNavigate();

  const handleSignOut = () => {
    onSignOut();
    navigate('/');
  };

  return (
    <div>
      <h2>Admin Portal</h2>
      <div style={{ marginBottom: '1rem', display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
        <button onClick={() => setTab('teachers')}>Manage Teachers</button>
        <button onClick={() => setTab('students')}>Manage Students</button>
        <button onClick={() => setTab('donations')}>View Donations</button>
        <button onClick={() => setTab('feed')}>Donation Feed</button>
        <button onClick={() => setTab('lawn-signs')}>Lawn Signs</button>
      </div>

      {tab === 'teachers' && <ManageTeachers />}
      {tab === 'students' && <ManageStudents />}
      {tab === 'donations' && <ViewDonations />}
      {tab === 'feed' && <DonationFeed />}
      {tab === 'lawn-signs' && <ManageLawnSigns />}

      <button
        onClick={handleSignOut}
        style={{
          marginTop: '2rem',
          padding: '10px 20px',
          backgroundColor: '#dc3545',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer'
        }}
      >
        Sign Out
      </button>
    </div>
  );
}

function ManageTeachers() {
  const [teachers, setTeachers] = useState([]);
  const [newTeacher, setNewTeacher] = useState('');
  const [gradeLevel, setGradeLevel] = useState('');
  const [addMessage, setAddMessage] = useState('');
  const [editingTeacherId, setEditingTeacherId] = useState(null);
  const [editingTeacherName, setEditingTeacherName] = useState('');

  useEffect(() => {
    fetch('https://server-ojqx.onrender.com/api/teachers')
      .then(res => res.json())
      .then(allTeachers => {
          setTeachers(allTeachers.filter(t => !t.isUnassigned)); 
      })
      .catch(err => console.error('Error fetching teachers:', err));
  }, []);

  const handleAddTeacher = async (e) => {
    e.preventDefault();
    setAddMessage('');
    try {
      const res = await fetch('https://server-ojqx.onrender.com/api/admin/teacher', {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({ name: newTeacher, grade: gradeLevel })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Add teacher failed');
      setTeachers(prev => [...prev, data.teacher]);
      setNewTeacher('');
      setGradeLevel('');
      setAddMessage('✅ Teacher added successfully!');
    } catch (err) {
      setAddMessage(`❌ ${err.message}`);
    }
  };
  
  const handleUpdateTeacherName = async (teacherId, newName) => {
    setAddMessage('');
    if (!newName.trim()) {
      setAddMessage('❌ Teacher name cannot be empty.');
      return;
    }
    
    try {
      const res = await fetch(`https://server-ojqx.onrender.com/api/admin/teacher/${teacherId}`, {
        method: 'PATCH',
        headers: getAuthHeaders(),
        body: JSON.stringify({ name: newName.trim() })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Update failed');
      
      setTeachers(prev => 
        prev.map(t => (t._id === teacherId ? data.teacher : t))
      );
      setEditingTeacherId(null);
      setEditingTeacherName('');
      setAddMessage('✅ Teacher name updated successfully!');

    } catch (err) {
      setAddMessage(`❌ ${err.message}`);
    }
  };

  const handleRemoveTeacher = async (teacherId) => {
    if (!window.confirm('Are you sure you want to remove this teacher? Deletion will fail if they have assigned students.')) return;
    try {
      const res = await fetch(`https://server-ojqx.onrender.com/api/admin/teacher/${teacherId}`, {
        method: 'DELETE',
        headers: getAuthHeaders()
      });
      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.error || 'Failed to remove teacher');
      }
      setTeachers(prev => prev.filter(t => t._id !== teacherId));
      setAddMessage('✅ Teacher successfully removed.');
    } catch (err) {
      alert(err.message);
    }
  };

  const sortedTeachers = [...teachers].sort(
    (a, b) => gradeOptions.indexOf(a.grade) - gradeOptions.indexOf(b.grade)
  );

  return (
    <div>
      <h3>Add a New Teacher</h3>
      <form onSubmit={handleAddTeacher} className="form-column">
        <input
          type="text"
          value={newTeacher}
          onChange={e => setNewTeacher(e.target.value)}
          placeholder="Teacher name"
          required
        />
        <select value={gradeLevel} onChange={e => setGradeLevel(e.target.value)} required>
          <option value="">Select Grade Level</option>
          {gradeOptions.map((grade, idx) => (
            <option key={idx} value={grade}>{grade}</option>
          ))}
        </select>
        <button type="submit">Add Teacher</button>
        {addMessage && <div>{addMessage}</div>}
      </form>

      <h3>Current Teachers</h3>
      <ul style={{ listStyleType: 'none', padding: 0 }}>
        {sortedTeachers.map(t => (
          <li key={t._id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
            {editingTeacherId === t._id ? (
              <form 
                onSubmit={(e) => {
                  e.preventDefault();
                  handleUpdateTeacherName(t._id, editingTeacherName);
                }}
                style={{ display: 'flex', gap: '5px', margin: '0', flexGrow: 1 }}
              >
                <input
                  type="text"
                  value={editingTeacherName}
                  onChange={e => setEditingTeacherName(e.target.value)}
                  style={{ flexGrow: 1, height: '30px', padding: '5px' }}
                  required
                />
                <button type="submit" style={{ padding: '5px 10px', fontSize: '0.8rem', backgroundColor: '#28a745' }}>
                  Save
                </button>
                <button 
                  type="button" 
                  onClick={() => {
                    setEditingTeacherId(null);
                    setAddMessage('');
                  }}
                  style={{ padding: '5px 10px', fontSize: '0.8rem', backgroundColor: '#6c757d' }}
                >
                  Cancel
                </button>
              </form>
            ) : (
              <span 
                style={{ cursor: 'pointer', flexGrow: 1, textAlign: 'left' }}
                onClick={() => {
                  setEditingTeacherId(t._id);
                  setEditingTeacherName(t.name);
                }}
                title="Click to edit name"
              >
                {t.name} ({t.grade})
              </span>
            )}
            
            {editingTeacherId !== t._id && (
              <span
                onClick={() => handleRemoveTeacher(t._id)}
                style={{
                  color: 'red',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  fontSize: '1.2rem',
                  marginLeft: '10px'
                }}
                title="Remove Teacher"
              >
                ❌
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

function ManageStudents() {
  const [teachers, setTeachers] = useState([]);
  const [students, setStudents] = useState([]);
  const [filterGrade, setFilterGrade] = useState('');
  const [selectedTeacher, setSelectedTeacher] = useState('');
  const [newStudentName, setNewStudentName] = useState('');
  const [newStudentEmail, setNewStudentEmail] = useState('');
  const fileInput = useRef();
  const [uploadMessage, setUploadMessage] = useState('');
  const [addStudentMessage, setAddStudentMessage] = useState('');

  const filteredTeachers = teachers.filter(t => t.grade === filterGrade);

  const fetchStudentsForTeacher = async (teacherId) => {
      if (!teacherId) {
          setStudents([]);
          return;
      }
      try {
          const res = await fetch(`https://server-ojqx.onrender.com/api/teachers/${teacherId}/students`);
          if (!res.ok) throw new Error('Failed to fetch students');
          const data = await res.json();
          setStudents(data);
      } catch (error) {
          console.error('Error fetching students:', error);
          setStudents([]);
      }
  };

  useEffect(() => {
    fetch('https://server-ojqx.onrender.com/api/teachers')
      .then(res => res.json())
      .then(allTeachers => {
          setTeachers(allTeachers.filter(t => !t.isUnassigned));
      })
      .catch(err => console.error('Error fetching teachers:', err));
  }, []);

  useEffect(() => {
    fetchStudentsForTeacher(selectedTeacher);
  }, [selectedTeacher]); 

  const handleUpload = async (e) => {
    e.preventDefault();
    setUploadMessage('');
    const file = fileInput.current.files[0];
    if (!file || !selectedTeacher) return setUploadMessage('Missing teacher or file');

    const formData = new FormData();
    formData.append('file', file);
    formData.append('teacherId', selectedTeacher);

    try {
      const res = await fetch('https://server-ojqx.onrender.com/api/admin/students/upload', {
        method: 'POST',
        headers: getAuthHeadersForFiles(),
        body: formData
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Upload failed');
      
      setUploadMessage(`✅ Uploaded ${data.count} students`);
      fileInput.current.value = '';
      await fetchStudentsForTeacher(selectedTeacher); 

    } catch (err) {
      setUploadMessage(`❌ ${err.message}`);
    }
  };

  const handleAddStudent = async (e) => {
    e.preventDefault();
    setAddStudentMessage('');

    if (!newStudentName) {
      setAddStudentMessage('❌ Please enter a student name.');
      return;
    }
    if (!selectedTeacher) {
      setAddStudentMessage('❌ Please select a teacher.');
      return;
    }

    try {
      const res = await fetch('https://server-ojqx.onrender.com/api/admin/students', {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({ 
          name: newStudentName, 
          teacherId: selectedTeacher,
          email: newStudentEmail 
        })
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Failed to add student');
      
      const addedStudent = data.addedStudent;
      if (addedStudent) {
        setStudents(prev => [...prev, addedStudent]);
      } else {
        await fetchStudentsForTeacher(selectedTeacher);
      }
      
      setNewStudentName('');
      setNewStudentEmail('');
      setAddStudentMessage('✅ Student added!');
      
    } catch (err) {
      setAddStudentMessage(`❌ ${err.message}`);
    }
  };

  const handleRemoveStudent = async (studentId) => {
    if (!window.confirm('Remove this student?')) return;
    try {
      const res = await fetch(`https://server-ojqx.onrender.com/api/admin/students/${studentId}`, {
        method: 'DELETE',
        headers: getAuthHeaders()
      });
      if (!res.ok) throw new Error('Failed to remove student');
      setStudents(prev => prev.filter(s => s._id !== studentId));
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div>
      <h3>Manage Students</h3>
      <form className="form-column">
        <select
          value={filterGrade}
          onChange={e => {
            setFilterGrade(e.target.value);
            setSelectedTeacher('');
          }}
          required
        >
          <option value="">Select Grade Level</option>
          {gradeOptions.map((grade, idx) => (
            <option key={idx} value={grade}>{grade}</option>
          ))}
        </select>

        <select
          value={selectedTeacher}
          onChange={e => setSelectedTeacher(e.target.value)}
          required
        >
          <option value="">Select a Teacher</option>
          {filteredTeachers.map(t => (
            <option key={t._id} value={t._id}>{t.name}</option>
          ))}
        </select>
      </form>

      {selectedTeacher && (
        <>
          <h4>Upload Students via Excel</h4>
          <p style={{fontSize: '0.85rem', color: '#666', marginBottom: '0.5rem'}}>
            Excel should have "Name" and "Email" column headers.
          </p>
          <form onSubmit={handleUpload} className="form-column">
            <input type="file" ref={fileInput} accept=".xlsx,.xls" />
            <button type="submit">Upload</button>
            {uploadMessage && <div>{uploadMessage}</div>}
          </form>

          <h4>Add Individual Student</h4>
          <form onSubmit={handleAddStudent} className="form-column">
            <input
              type="text"
              value={newStudentName}
              onChange={e => setNewStudentName(e.target.value)}
              placeholder="Student name"
              required
            />
            <input
              type="email"
              value={newStudentEmail}
              onChange={e => setNewStudentEmail(e.target.value)}
              placeholder="Student email (optional)"
            />
            <button type="submit">Add Student</button>
            {addStudentMessage && <div>{addStudentMessage}</div>}
          </form>

          <h4>Current Students</h4>
          <ul style={{ listStyleType: 'none', padding: 0 }}>
            {students.map(s => (
              <li key={s._id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
                <span>
                  {s.name} {s.email && <small style={{color: '#666'}}>({s.email})</small>}
                </span>
                <span
                  onClick={() => handleRemoveStudent(s._id)}
                  style={{
                    color: 'red',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    fontSize: '1.2rem',
                  }}
                  title="Remove Student"
                >
                  ❌
                </span>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}

function ViewDonations() {
  const [teachers, setTeachers] = useState([]);
  const [filterGrade, setFilterGrade] = useState('');
  const [selectedTeacher, setSelectedTeacher] = useState('');
  const [donations, setDonations] = useState([]);
  const [fundraisingGoal, setFundraisingGoal] = useState('');
  const [goalMessage, setGoalMessage] = useState('');
  const [currentGoal, setCurrentGoal] = useState(null); 

  const filteredTeachers = teachers.filter(t => t.grade === filterGrade);
  
  useEffect(() => {
    fetch('https://server-ojqx.onrender.com/api/donations/progress')
      .then(res => res.json())
      .then(data => {
          setCurrentGoal((data.goal / 100).toFixed(2)); 
      })
      .catch(err => {
          console.error('Error fetching current goal:', err);
          setCurrentGoal('Error');
      });
  }, []);

  const handleSetGoal = async (e) => {
      e.preventDefault();
      setGoalMessage('');

      if (!fundraisingGoal || parseFloat(fundraisingGoal) <= 0) {
          setGoalMessage('❌ Please enter a valid goal amount.');
          return;
      }

      try {
          const res = await fetch('https://server-ojqx.onrender.com/api/admin/set-goal', {
              method: 'POST',
              headers: getAuthHeaders(),
              body: JSON.stringify({ goalAmount: fundraisingGoal })
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.error || 'Failed to set goal');
          
          setCurrentGoal((data.goal / 100).toFixed(2));
          setGoalMessage(`✅ Goal successfully set to $${(data.goal / 100).toFixed(2)}`);
          setFundraisingGoal('');
      } catch (err) {
          setGoalMessage(`❌ ${err.message}`);
      }
  };

  useEffect(() => {
    fetch('https://server-ojqx.onrender.com/api/teachers')
      .then(res => res.json())
      .then(setTeachers)
      .catch(err => console.error('Error fetching teachers:', err));
  }, []);

  useEffect(() => {
    if (!selectedTeacher) {
        setDonations([]);
        return;
    }
    fetch(`https://server-ojqx.onrender.com/api/admin/students/${selectedTeacher}/donations`, {
      headers: getAuthHeaders()
    })
      .then(res => res.json())
      .then(data => setDonations(Array.isArray(data) ? data : []))
      .catch(() => setDonations([]));
  }, [selectedTeacher]);

  return (
    <div>
      <h3>
        Set Fundraising Goal (Current Goal: {currentGoal === null ? 'Loading...' : (currentGoal === 'Error' ? 'Error' : `$${currentGoal}`)})
      </h3>
      <form onSubmit={handleSetGoal} className="form-column" style={{ maxWidth: '300px', margin: '1rem auto' }}>
          <input
              type="number"
              step="0.01"
              min="1"
              value={fundraisingGoal}
              onChange={(e) => setFundraisingGoal(e.target.value)}
              placeholder="Enter new goal amount ($)"
              required
          />
          <button type="submit">Set Goal</button>
          {goalMessage && <div>{goalMessage}</div>}
      </form>
      
      <h3>View Student Donations</h3>
      <form className="form-column">
        <select
          value={filterGrade}
          onChange={e => {
            setFilterGrade(e.target.value);
            setSelectedTeacher('');
          }}
          required
        >
          <option value="">Select Grade Level</option>
          {gradeOptions.map((grade, idx) => (
            <option key={idx} value={grade}>{grade}</option>
          ))}
        </select>

        <select
          value={selectedTeacher}
          onChange={e => setSelectedTeacher(e.target.value)}
          required
        >
          <option value="">Select a Teacher</option>
          {filteredTeachers.map(t => (
            <option key={t._id} value={t._id}>{t.name}</option>
          ))}
        </select>
      </form>

      {selectedTeacher && (
        <div style={{ marginTop: '1rem' }}>
          <table>
            <thead>
              <tr>
                <th>Student Name</th>
                <th>Total Donated ($)</th>
                <th># of Donations</th>
              </tr>
            </thead>
            <tbody>
              {donations.map((entry, idx) => (
                <tr key={idx}>
                  <td>{entry.studentName}</td>
                  <td>{(entry.total / 100).toFixed(2)}</td>
                  <td>{entry.count}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

function DonationFeed() {
  const [donations, setDonations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [filterGrade, setFilterGrade] = useState('');
  const [filterTeacher, setFilterTeacher] = useState('');
  const [filterStudent, setFilterStudent] = useState('');
  const [allTeachers, setAllTeachers] = useState([]);
  const [allStudents, setAllStudents] = useState([]);

  const filteredTeachers = React.useMemo(() => {
    if (!filterGrade) return [];
    return allTeachers.filter(t => t.grade === filterGrade && !t.isUnassigned);
  }, [filterGrade, allTeachers]);

  const filteredStudents = React.useMemo(() => {
    if (!filterTeacher) return [];
    return allStudents.filter(s => s.teacher === filterTeacher);
  }, [filterTeacher, allStudents]);

  useEffect(() => {
    fetch('https://server-ojqx.onrender.com/api/teachers', { headers: getAuthHeaders() })
      .then(res => res.json())
      .then(setAllTeachers)
      .catch(err => console.error('Failed to fetch teachers for filter', err));

    fetch('https://server-ojqx.onrender.com/api/students', { headers: getAuthHeaders() })
      .then(res => res.json())
      .then(setAllStudents)
      .catch(err => console.error('Failed to fetch students for filter', err));
  }, []);

  useEffect(() => {
    const fetchDonationFeed = async () => {
      setLoading(true);
      setError('');
      
      const params = new URLSearchParams();
      if (filterGrade) params.append('grade', filterGrade);
      if (filterTeacher) params.append('teacher', filterTeacher);
      if (filterStudent) params.append('student', filterStudent);
      
      const queryString = params.toString();
      
      try {
        const res = await fetch(`https://server-ojqx.onrender.com/api/admin/donations/feed?${queryString}`, {
          headers: getAuthHeaders()
        });
        if (!res.ok) {
          const data = await res.json();
          throw new Error(data.error || 'Failed to fetch donation feed');
        }
        const data = await res.json();
        setDonations(data);
      } catch (err) {
        setError(`❌ ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchDonationFeed();
  }, [filterGrade, filterTeacher, filterStudent]);

  if (error) return <div style={{ color: 'red' }}>{error}</div>;

  return (
    <div>
      <h3>Donation Feed (Newest First)</h3>
      <form className="form-column" style={{ maxWidth: '500px', margin: '1rem auto' }}>
        <select
          value={filterGrade}
          onChange={e => {
            setFilterGrade(e.target.value);
            setFilterTeacher('');
            setFilterStudent('');
          }}
        >
          <option value="">All Grades</option>
          {filterGradeOptions.map((grade, idx) => (
            grade && <option key={idx} value={grade}>{grade}</option>
          ))}
        </select>

        <select
          value={filterTeacher}
          onChange={e => {
            setFilterTeacher(e.target.value);
            setFilterStudent('');
          }}
          disabled={!filterGrade}
        >
          <option value="">All Teachers</option>
          {filteredTeachers.map(t => (
            <option key={t._id} value={t._id}>{t.name}</option>
          ))}
        </select>

        <select
          value={filterStudent}
          onChange={e => setFilterStudent(e.target.value)}
          disabled={!filterTeacher}
        >
          <option value="">All Students</option>
          {filteredStudents.map(s => (
            <option key={s._id} value={s._id}>{s.name}</option>
          ))}
        </select>
      </form>
      
      {loading ? (
        <div>Loading donation feed...</div>
      ) : (
        <div style={{ marginTop: '1rem', maxHeight: '500px', overflowY: 'auto' }}>
          <table>
            <thead>
              <tr>
                <th>Time Donated</th>
                <th>Donor Name</th>
                <th>Student</th>
                <th>Amount ($)</th>
              </tr>
            </thead>
            <tbody>
              {donations.length === 0 && (
                <tr>
                  <td colSpan="4">No donations found.</td>
                </tr>
              )}
              {donations.map(donation => (
                <tr key={donation._id}>
                  <td>{new Date(donation.createdAt).toLocaleString()}</td>
                  <td>{donation.donorName || 'Anonymous'}</td>
                  <td>{donation.student ? donation.student.name : 'Unknown Student'}</td>
                  <td>{(donation.amount / 100).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

// --- NEW COMPONENT: MANAGE LAWN SIGNS ---
function ManageLawnSigns() {
  const [lawnSignEnabled, setLawnSignEnabled] = useState(true);
  const [lawnSigns, setLawnSigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchLawnSignData();
  }, []);

  const fetchLawnSignData = async () => {
    setLoading(true);
    setError('');
    try {
      const [settingsRes, signsRes] = await Promise.all([
        fetch('https://server-ojqx.onrender.com/api/settings', { headers: getAuthHeaders() }),
        fetch('https://server-ojqx.onrender.com/api/admin/lawn-signs', { headers: getAuthHeaders() })
      ]);

      if (settingsRes.ok) {
        const settingsData = await settingsRes.json();
        setLawnSignEnabled(settingsData.lawnSignEnabled);
      }

      if (signsRes.ok) {
        const signsData = await signsRes.json();
        setLawnSigns(Array.isArray(signsData) ? signsData : []);
      }
    } catch (err) {
      setError(`❌ Failed to load lawn sign data: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleToggleLawnSign = async () => {
    setUpdating(true);
    try {
      const newStatus = !lawnSignEnabled;
      const res = await fetch('https://server-ojqx.onrender.com/api/admin/settings/toggle-lawn-sign', {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({ enabled: newStatus })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Failed to update toggle setting');
      setLawnSignEnabled(data.lawnSignEnabled);
    } catch (err) {
      alert(`❌ ${err.message}`);
    } finally {
      setUpdating(false);
    }
  };

  if (loading) return <div>Loading Lawn Signs Dashboard...</div>;
  if (error) return <div style={{ color: 'red' }}>{error}</div>;

  return (
    <div style={{ maxWidth: '900px', margin: '0 auto' }}>
      <h3>Lawn Signs Feature Control</h3>
      
      {/* --- TOGGLE BOX --- */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#f8f9fa',
        padding: '1.25rem',
        borderRadius: '8px',
        border: '1px solid #ccc',
        marginBottom: '2rem'
      }}>
        <div style={{ textAlign: 'left' }}>
          <h4 style={{ margin: '0 0 0.25rem 0' }}>Lawn Sign Upsell Option</h4>
          <p style={{ margin: 0, fontSize: '0.9rem', color: '#555' }}>
            Status: <strong style={{ color: lawnSignEnabled ? '#28a745' : '#dc3545' }}>
              {lawnSignEnabled ? 'ENABLED (Visible to Donors)' : 'DISABLED (Hidden from Donors)'}
            </strong>
          </p>
        </div>

        <button
          onClick={handleToggleLawnSign}
          disabled={updating}
          style={{
            padding: '10px 20px',
            borderRadius: '5px',
            border: 'none',
            fontWeight: 'bold',
            cursor: updating ? 'not-allowed' : 'pointer',
            backgroundColor: lawnSignEnabled ? '#dc3545' : '#28a745',
            color: '#ffffff'
          }}
        >
          {updating ? 'Updating...' : lawnSignEnabled ? 'Disable Lawn Signs' : 'Enable Lawn Signs'}
        </button>
      </div>

      {/* --- LAWN SIGNS LIST --- */}
      <h3>Purchased Lawn Signs ({lawnSigns.length} Total)</h3>
      {lawnSigns.length === 0 ? (
        <p style={{ color: '#666' }}>No lawn signs have been purchased yet.</p>
      ) : (
        <div style={{ overflowX: 'auto', maxHeight: '500px', overflowY: 'auto' }}>
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Purchased By</th>
                <th>Receipt Email</th>
                <th>Student</th>
                <th>Teacher / Grade</th>
                <th>Message</th>
              </tr>
            </thead>
            <tbody>
              {lawnSigns.map((sign) => (
                <tr key={sign._id}>
                  <td>{new Date(sign.createdAt).toLocaleDateString()}</td>
                  <td style={{ fontWeight: 'bold' }}>{sign.donorName || 'Anonymous'}</td>
                  <td>{sign.donorEmail || 'N/A'}</td>
                  <td>{sign.student ? sign.student.name : 'N/A'}</td>
                  <td>{sign.teacher ? `${sign.teacher.name} (${sign.teacher.grade})` : 'N/A'}</td>
                  <td style={{ fontStyle: 'italic', color: '#003f7f', fontWeight: 'bold' }}>
                    "{sign.lawnSignMessage}"
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default AdminPage;